import React, { useState, useEffect } from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

function LandingPage() {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState({
    days: 14,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    // Target date: 14 days from current date (April 9, 2026)
    const targetDate = new Date("2026-04-09T13:21:41+01:00").getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        clearInterval(timer);
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="wip-overlay">
        <div className="wip-dialog">
          <div className="wip-icon">🚧</div>
          <h2 className="wip-title">Website In Progress</h2>
          <p className="wip-message">
            We are working hard behind the scenes to bring you a great experience. Please check back soon!
          </p>
          <div className="wip-countdown">
            <div className="countdown-box">
              <span className="countdown-number">{timeLeft.days}</span>
              <span className="countdown-label">Days</span>
            </div>
            <div className="countdown-box">
              <span className="countdown-number">{timeLeft.hours}</span>
              <span className="countdown-label">Hours</span>
            </div>
            <div className="countdown-box">
              <span className="countdown-number">{timeLeft.minutes}</span>
              <span className="countdown-label">Minutes</span>
            </div>
            <div className="countdown-box">
              <span className="countdown-number">{timeLeft.seconds}</span>
              <span className="countdown-label">Seconds</span>
            </div>
          </div>
        </div>
      </div>
      <main className="min-h-screen bg-gradient" style={{ filter: 'blur(8px)', height: '100vh', overflow: 'hidden', pointerEvents: 'none', userSelect: 'none' }}>
        {/* Navigation */}
        <nav className="nav">
          <div className="container">
            <div className="nav-inner">
              <div className="logo">
                <img
                  src="/cirupay-logo-compact.svg"
                  alt="CiruPay Logo"
                  className="logo-image"
                />
              </div>
              <div className="nav-links">
                <button
                  onClick={() => scrollToSection("features")}
                  className="nav-link"
                >
                  Features
                </button>
                <button
                  onClick={() => scrollToSection("about")}
                  className="nav-link"
                >
                  About
                </button>
                <button
                  onClick={() => scrollToSection("contact")}
                  className="nav-link"
                >
                  Contact
                </button>
                <button className="btn" onClick={() => navigate('/waitlist')}>Get Started</button>
              </div>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="hero">
          <div className="container">
            <div className="hero-content">
              <div>
                <h1 className="hero-title">
                  Save Together,
                  <span className="hero-gradient"> Grow Together</span>
                </h1>
                <p className="hero-description">
                  Join savings circles with friends and family. Build financial
                  habits, reach your goals faster, and strengthen your community
                  bonds.
                </p>
                <div className="hero-buttons">
                  <button className="btn btn-lg" onClick={() => navigate('/waitlist')}>Start Your Circle</button>
                  <button className="btn btn-outline btn-lg">Learn More</button>
                </div>
                <div className="hero-features">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <div className="feature-dot"></div>
                    <span>FDIC Insured</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <div className="feature-dot"></div>
                    <span>Bank-Level Security</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <div className="feature-dot"></div>
                    <span>Free to Use</span>
                  </div>
                </div>
              </div>
              <div>
                <div className="hero-card">
                  <div style={{ textAlign: "center" }}>
                    <div className="hero-card-icon">
                      <span>$</span>
                    </div>
                    <h3
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: 600,
                        color: "#111827",
                        marginBottom: "0.5rem",
                      }}
                    >
                      Family Vacation Fund
                    </h3>
                    <div
                      style={{
                        background: "#f3f4f6",
                        borderRadius: "0.5rem",
                        padding: "1rem",
                        marginBottom: "1rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "0.875rem",
                          color: "#4b5563",
                          marginBottom: "0.25rem",
                        }}
                      >
                        <span>Progress</span>
                        <span>$3,200 / $5,000</span>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          background: "#e5e7eb",
                          borderRadius: "9999px",
                          height: "0.5rem",
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #059669, #0d9488)",
                            height: "0.5rem",
                            borderRadius: "9999px",
                            width: "60%",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div style={{ fontSize: "0.875rem", color: "#4b5563" }}>
                      <p>4 members • $200/month each</p>
                      <p style={{ marginTop: "0.25rem" }}>2 months remaining</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="features" className="features">
          <div className="container">
            <div>
              <h2 className="section-title">Everything You Need to Save Smart</h2>
              <p className="section-description">
                CiruPay combines the power of community with modern fintech to
                make saving easier and more rewarding.
              </p>
            </div>
            <div className="features-grid">
              {[
                {
                  icon: "👥",
                  title: "Savings Circles",
                  description:
                    "Create or join circles with friends, family, or like-minded savers to reach your goals together.",
                },
                {
                  icon: "🎯",
                  title: "Goal Tracking",
                  description:
                    "Set clear financial goals and track your progress with beautiful, motivating visualizations.",
                },
                {
                  icon: "🔒",
                  title: "Secure & Insured",
                  description:
                    "Bank-level security with FDIC insurance ensures your money is always safe and protected.",
                },
                {
                  icon: "📱",
                  title: "Mobile First",
                  description:
                    "Manage your savings on-the-go with our intuitive mobile app designed for modern life.",
                },
                {
                  icon: "💳",
                  title: "Easy Payments",
                  description:
                    "Seamless integration with your bank accounts and cards for effortless contributions.",
                },
                {
                  icon: "📊",
                  title: "Smart Insights",
                  description:
                    "Get personalized insights and recommendations to optimize your saving strategy.",
                },
              ].map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon">{feature.icon}</div>
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats">
          <div className="container">
            <div className="stats-grid">
              <div>
                <div className="stat-number">$50M+</div>
                <div className="stat-label">Total Saved</div>
              </div>
              <div>
                <div className="stat-number">25K+</div>
                <div className="stat-label">Active Users</div>
              </div>
              <div>
                <div className="stat-number">5K+</div>
                <div className="stat-label">Circles Created</div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section id="about" className="cta">
          <div className="container">
            <h2 className="cta-title">Ready to Start Your Saving Journey?</h2>
            <p className="cta-description">
              Join thousands of users who are already saving smarter with CiruPay.
            </p>
            <div className="cta-buttons">
              <button className="btn btn-lg" onClick={() => navigate('/waitlist')}>Download for iOS</button>
              <button className="btn btn-white btn-lg" onClick={() => navigate('/waitlist')}>
                Download for Android
              </button>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer id="contact" className="footer">
          <div className="container">
            <div className="footer-grid">
              <div>
                <div className="footer-brand">
                  <div className="logo">
                    <img
                      src="/cirupay-logo-compact.svg"
                      alt="CiruPay Logo"
                      className="logo-image footer-logo"
                    />
                  </div>
                </div>
                <p className="footer-description">
                  Building better financial futures through community-powered
                  saving.
                </p>
              </div>
              <div>
                <h3 className="footer-title">Product</h3>
                <div className="footer-links">
                  <button className="footer-link">Features</button>
                  <button className="footer-link">Pricing</button>
                  <button className="footer-link">Security</button>
                  <button className="footer-link">API</button>
                </div>
              </div>
              <div>
                <h3 className="footer-title">Company</h3>
                <div className="footer-links">
                  <button className="footer-link">About</button>
                  <button className="footer-link">Careers</button>
                  <button className="footer-link">Press</button>
                  <button className="footer-link">Blog</button>
                </div>
              </div>
              <div>
                <h3 className="footer-title">Support</h3>
                <div className="footer-links">
                  <button className="footer-link">Help Center</button>
                  <button className="footer-link">Contact</button>
                  <button className="footer-link" onClick={() => navigate('/privacy')}>Privacy</button>
                  <button className="footer-link" onClick={() => navigate('/terms')}>Terms</button>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <p style={{ marginBottom: "0.5rem" }}>
                CiruPay is a financial coordination platform and is not a bank or financial institution.
              </p>
              <p style={{ marginBottom: "0.5rem" }}>CiruPay Inc. — Registered in Delaware, United States.</p>
              <p>
                &copy; 2026 CiruPay Inc. All rights reserved.
                {" | "}
                <button className="footer-link" onClick={() => navigate('/privacy')} style={{ display: "inline", padding: 0 }}>Privacy Policy</button>
                {" | "}
                <button className="footer-link" onClick={() => navigate('/terms')} style={{ display: "inline", padding: 0 }}>Terms of Service</button>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </>
  );
}

export default LandingPage;
